import { Modules } from '../api/schemas/schema'

export const getModuleType = (module: Modules) => {
   if (module.riskManagementModule !== null && module.riskManagementModule !== undefined) {
      return { moduleType: 'riskManagementModule', moduleEnumValue: module.riskManagementModule }
   }
   if (module.component !== null && module.component !== undefined) {
      return { moduleType: 'component', moduleEnumValue: module.component }
   }
   if (module.demandComplianceModuleDefinitionId) {
      return { moduleType: 'demandComplianceModuleDefinitionId', moduleEnumValue: module.demandComplianceModuleDefinitionId }
   }
   return null
}

export const getModuleName = (module: Modules, enumOptions: any) => {
   const moduleType = getModuleType(module)
   return moduleType?.moduleEnumValue !== null ? enumOptions[moduleType.moduleEnumValue] : ''
}
